// Announcment Bar Animations
setInterval(function() {
  var total_length=document.querySelectorAll('.eam-custom-cart-banner-item').length;
  var announcmentbar_element=document.querySelectorAll('.eam-custom-cart-banner-item');
  for(var j=0;j<total_length;j++){
    if(announcmentbar_element[j].className.includes('eam-banner-showing')){
      announcmentbar_element[j].classList.remove('eam-banner-showing');
      if(j+1<total_length){
        announcmentbar_element[j+1].classList.add('eam-banner-showing');
      }else{
        announcmentbar_element[0].classList.add('eam-banner-showing');
      }
      var new_height=document.querySelector('.eam-custom-cart-banner-item.eam-banner-showing').clientHeight+'px';
       document.querySelector('.eam-custom-cart-banner-move').style.minHeight=new_height; 
      break;
    }
  }

 }, 5000);

// Announcment Bar Animation END
// Cart Open
function openMainCart(){
      opemEamCart();
}
function opemEamCart(){
  document.querySelector('.eam-cart-container').style.right='0px';
  document.querySelector('.eam-custom-cart-overlay').style.display="block";
  document.querySelector('body').classList.add('eam-no-scroll');
  eamcartrender();
}
if(eam_cart_trigger_idclass != ''){
  var all_trigger_element = document.querySelectorAll(eam_cart_trigger_idclass);
  for(var j=0;j<all_trigger_element.length;j++){
    all_trigger_element[j].addEventListener('click',function(e){
      e.preventDefault();
        opemEamCart();
    });
  }
    
}



// Cart Close
document.querySelector('.eam-cart-close').addEventListener('click',function(){
  document.querySelector('.eam-cart-container').style.right='-1000px';
  document.querySelector('.eam-custom-cart-overlay').style.display="none";
  document.querySelector('body').classList.remove('eam-no-scroll');
});
document.querySelector('.eam-custom-cart-overlay').addEventListener('click',function(){
  document.querySelector('.eam-cart-container').style.right='-1000px';
  document.querySelector('.eam-custom-cart-overlay').style.display="none";
  document.querySelector('body').classList.remove('eam-no-scroll');
});
// Cart Close END

// Input Field Link with Cart Quantity
//plus icon
$(document).on('click','.eam-cart-quantity-icon.eam-cart-quantity__plus-icon',function(){
  var item_line_id = $(this).parents('.eam-cart-item').data('product-line');
  var current_quantity=this.parentElement.querySelector('.eam-cart-quantity').value;
  current_quantity=parseInt(current_quantity)+1;
  this.parentElement.querySelector('.eam-cart-quantity').value=current_quantity;
  // Call Update Cart Function
  change_item_quantity(item_line_id,current_quantity);
});
$(document).on('click','.eam-cart-quantity-icon.eam-cart-quantity__minus-icon',function(){
  var item_line_id = $(this).parents('.eam-cart-item').data('product-line');
  var current_quantity=this.parentElement.querySelector('.eam-cart-quantity').value;

  current_quantity=parseInt(current_quantity)-1;
  if(current_quantity>=0){
    this.parentElement.querySelector('.eam-cart-quantity').value=current_quantity;
  }
  // Call Update Cart Function
  change_item_quantity(item_line_id,current_quantity);
  
});

$(document).on('click','.eam-cart-item .eam-cart-remove-item',function() {
  var item_line_id = $(this).parents('.eam-cart-item').data('product-line');
  $(this).parents('.eam-cart-remove-item-container').addClass('eam-remove-loading');
  $(this).parents('.eam-cart-remove-item-container').html(eam_loading_icon);
  var current_quantity = 0;
  change_item_quantity(item_line_id,current_quantity);
  
});

async function change_item_quantity(product_id,current_quantity){
  $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      async: true,
      data: {
        'line':  product_id,
        'quantity': current_quantity
      },
      dataType: 'json',
      success: addToCartOk
  });
}

function addItem(form_id) {
   $.ajax({
      type: 'POST', 
      url: '/cart/add.js',
      dataType: 'json', 
      data: $('#'+form_id).serialize(),
      success: addToCartOk
   });
}

function addItemAddons(variant_id,e) {
  e.addClass('eam-addon-adding');
  e.text('ADDING TO CART');
   $.ajax({
      type: 'POST', 
      url: '/cart/add.js',
      dataType: 'json', 
      data: {
        id: variant_id,
        quantity: 1
      },
      success: addonsAddToCartOk,
      error: addonsAddToCartFail
   });
}

function addonsAddToCartFail(result) {
  if(result.responseJSON.status == 422){
    $('.eam-addon-adding').text('Sold Out');
    $('.eam-addon-adding').addClass('eam-ajax-outofstock');
    $('.eam-addon-adding').removeClass('eam-addon-adding');
  }
}
function addToCartOk(product) { 
  openMainCart();
  // openMainCart();
}

function addonsAddToCartOk(product){
  // $('.eam-addon-adding').text(addon_atc_text);
  $('.eam-addon-adding').removeClass('eam-addon-adding');
  openMainCart();
  $('.eam-cart-items-container')[0].scrollIntoView({behavior: 'smooth'});
}
// open cart on item submit

$(document).on('click','form[action="/cart/add"] [type="submit"]',function(e) {
  e.preventDefault();
  var form_id=$(this).parents('form').attr('id');
  addItem(form_id);
  // // 2nd Way
  // setTimeout(function() {
  //   opemEamCart();
  // },500)
});

// Render Cart
function eamcartrender() {
  jQuery.getJSON('/cart.js', function(cart) {
    $('.eam-cart-addon-item-container').addClass('eam-cart-addon-empty');
    $('.eam-cart-free-shipping-text-container .eam-cart-free-shipping-disclaimer').hide();
    RenderCartItem(cart);
    if(addon_type != 'static'){
      $('.eam-cart-addon-item-container').html('<p class="eam_addon_message">'+eam_loading_icon+'</p>')
      $('.eam-cart-addon-heading-container').show();
      $('.eam-cart-middle-container').css('padding','0px 0px 0px');

      
    }
    if(addon_type=='collection'){
      if(cart.items.length>0){
        RenderAddonsCollection(cart);
      }else{
       if(show_empty_cart_product){
        RenderEmptyAddons(cart);
       }else{
        RenderAddonsCollection(cart);
       }
      }
    }else if(addon_type == 'tag_based'){
      if(cart.items.length>0){
        RenderAddonsTags(cart);
      }else{
       if(show_empty_cart_product){
        RenderEmptyAddons(cart);
       }else{
        RenderAddonsCollection(cart);
       }
      }
    }
    if(enable_free_gift){
      EamFreeProduct(cart);  
    }
  });
}

function RenderCartItem(cart) {
    var total_cart_price = current_currency + '' +(cart.total_price/100.00).toFixed(2);
    var tag_text = free_gift_text;
    var original_total_cart_price="none",cart_discount_name;
    if(cart.original_total_price>cart.total_price){
      original_total_cart_price=current_currency + '' +(cart.original_total_price/100.00).toFixed(2);
    }
    if(cart.cart_level_discount_applications.length>0){
      cart_discount_name = cart.cart_level_discount_applications[0].title;
      $('.eam-cart-subtotal-text').html('Subtotal <span class="eam-cart-discount-text" data-discount="'+cart_discount_name+'">'+cart_discount_name+'</span>');
    }
    if(!show_subtotal_cbutton){
      $('.eam-cart-subtotal-price').html('<span class="eam-cart-original-subtotal-price" data-price="'+original_total_cart_price+'">'+original_total_cart_price+'</span><span class="eam-cart-subtotal-price-text" data-price="'+total_cart_price+'">'+total_cart_price+'</span>');
      
    }else{
      $('.eam-cart-subtotal-price').html('<span class="eam-cart-original-subtotal-price" data-price="'+original_total_cart_price+'">'+original_total_cart_price+'</span><span class="eam-cart-subtotal-price-text" data-price="'+total_cart_price+'">'+checkout_button_text+' - '+total_cart_price+'</span>');
    }
    $(eam_cart_count_idclass).text(cart.item_count);
    $('.eam-cart-heading').attr('data-count',cart.item_count);
  
    if(cart.item_count>0){
      $('.eam-cart-addon-item-container').removeClass('eam-cart-addon-empty');
      
      $('.eam-cart-bottom-container').show();
      var new_padding = document.querySelector('.eam-cart-bottom-container').offsetHeight+30;
      document.querySelector('.eam-cart-addon-item-container').style.paddingBottom=new_padding+'px';
      $('.eam-cart-empty-heading-container').remove();
      $('.eam-cart-items-container').show();
      document.querySelector('.eam-cart-items-container').innerHTML = '';
      var current_item,eam_product_title,eam_variant_title,eam_product_price,eam_original_price,current_cart_items,new_item,product_url,discount_name;
      for(var j=0;j<cart.items.length;j++){
        var current_cart_items= document.querySelector('.eam-cart-items-container').innerHTML;
        current_item = cart.items[j];
        if(current_item!=undefined){
            var item_class = 'eam-cart-item';
            eam_product_title = current_item.product_title;
            eam_variant_title = current_item.variant_title;
            eam_product_price = current_currency+''+(current_item.price / 100.00).toFixed(2);
            eam_original_price = 'none';
            discount_name = 'none';
            if(eam_product_title == eam_variant_title){
              eam_variant_title = 'none';
            }
            if(current_item.discounts.length>0){
              if(current_item.discounted_price<current_item.price){
                eam_original_price = eam_product_price;
              }
              eam_product_price = current_currency+''+(current_item.discounted_price / 100.00).toFixed(2);
              discount_name = current_item.discounts[0].title;
            }
            if(free_gift_product != undefined && free_gift_product_handle == current_item.handle && enable_free_gift ){
              item_class = 'eam-cart-item free-item';
              eam_product_price = '0.00';
              tag_text = free_gift_text;
              product_url = '#';
            }else if(current_item.properties && current_item.properties[backorder_property_text]){
                item_class = 'eam-cart-item backorder-item';
                tag_text = backorder_tag_text;
                product_url = current_item.url;
            }else{
              tag_text = 'none';
              product_url = current_item.url;
              
            }
            
            new_item = '<div class="'+item_class+'" data-product-line="'+(j+1)+'" data-product-handle="'+current_item.handle+'"> <a class="eam-cart-item-image-container" href="'+product_url+'" tabindex="-1" aria-hidden="true"> <img class="eam-cart-item-image" alt="" src="'+current_item.image+'"> </a> <div class="eam-cart-data-container"> <a class="eam-cart-title-container" href="'+product_url+'"> <h2 class="eam-cart-title"> '+eam_product_title+' </h2> <p data-variant-title="'+eam_variant_title+'" class="eam-cart-vtitle"> '+eam_variant_title+'</p> <span class="eam-tag-text" data-tag="'+tag_text+'">'+tag_text+'</span> <span class="eam-discount-text" data-discount="'+discount_name+'">'+discount_name+'</span> </a> <div class="eam-cart-price-container"> <div class="eam-cart-price"><span class="eam-original-price" data-original-price="'+eam_original_price+'">'+eam_original_price+'</span> '+eam_product_price+' </div> <div class="eam-cart-item-number"> x <span class="eam-cart-item-quantity">'+current_item.quantity+'</span> </div> </div> <div class="eam-cart-quantity-container"> <button type="button" class="eam-cart-quantity-icon eam-cart-quantity__minus-icon" aria-label="Decrease quantity">-</button> <input type="number" class="eam-cart-quantity" aria-label="Quantity" value="'+current_item.quantity+'"> <button type="button" class="eam-cart-quantity-icon eam-cart-quantity__plus-icon" aria-label="Increase quantity">+</button> </div> <div class="eam-cart-remove-item-container"> <button type="button" class="eam-cart-remove-item" aria-label="Remove item from cart">'+eam_trash_icon+'</button> </div> </div> </div>';
            document.querySelector('.eam-cart-items-container').innerHTML = current_cart_items + new_item;
        }
      }
      if( eam_shipping_enable || enable_free_gift ){
        calculateshipping(cart);
      }
    }else{
      $('.eam-cart-bottom-container').hide();
      document.querySelector('.eam-cart-addon-item-container').style.paddingBottom='0px';
      if(document.querySelector('.eam-shipping-bar')){
        document.querySelector('.eam-shipping-bar').style.width='0';
      }
      $('.eam-cart-items-container').hide();
      $('.eam-cart-empty-heading-container').remove();
      document.querySelector('.eam-cart-middle-container').innerHTML = '<div class="eam-cart-empty-heading-container"> <h2 class="eam-cart-empty-heading">'+empty_cart_text+'</h2> </div>'+document.querySelector('.eam-cart-middle-container').innerHTML;
    }
}

function calculateshipping(cart) {
  var total_cart_price = cart.total_price/100.00;
  var free_shipping_price = parseFloat(eam_shipping_price);
  var free_product_price = parseFloat(free_gift_price);
  var current_width = (total_cart_price/free_shipping_price)*100;
  var current_amount_needed = 0;
  var shipping_text,current_text;
  var current_selected_price;
  var disclarmair_text_update = false;
  if(enable_free_gift && eam_shipping_enable){
    if(free_product_price>free_shipping_price){
        current_width = ((total_cart_price)/free_shipping_price)*100;
        current_text = eam_shipping_text;
          current_selected_price = free_shipping_price;
        if(current_width>=100){
          disclarmair_text_update = true;
          current_text = eam_product_text;
          current_selected_price = free_product_price;
          current_width = (total_cart_price/free_product_price)*100;
          if(current_width<=50){
            current_width = 60;
          }
        }else{
          current_width = current_width/2;
        }

    }else{
        current_width = ((total_cart_price)/free_product_price)*100;
        current_text = eam_product_text;
        current_selected_price = free_product_price;
        if(current_width>=100){
          current_text = eam_shipping_text;
          current_selected_price = free_shipping_price;
          current_width = (total_cart_price/free_shipping_price)*100;
          if(current_width<=50){
            current_width = 60;
          }
        }else{
          current_width = current_width/2;
        }
    }
    if(current_width>=100){
      if(free_product_price<free_shipping_price){
        disclarmair_text_update = true;
        document.querySelector('.eam-cart-free-shipping-disclaimer').textContent=disclaimer_free_text;
        
      }
      shipping_text = eam_free_shipping_text;
      current_width = 97.00;
      document.querySelector('.eam-cart-free-shipping-bar-container').classList.add('eam-free-shipping');
    }else{
      if(free_product_price<free_shipping_price){
        document.querySelector('.eam-cart-free-shipping-disclaimer').textContent=disclaimer_text;
      }
      document.querySelector('.eam-cart-free-shipping-bar-container').classList.remove('eam-free-shipping');
      current_amount_needed = current_currency +""+( current_selected_price - total_cart_price ).toFixed(2);
      shipping_text = 'Spend <strong>'+current_amount_needed+' </strong>'+current_text;
    }
    $('.eam-cart-free-shipping-text').html(shipping_text);
    if(document.querySelector('.eam-shipping-bar')){
      document.querySelector('.eam-shipping-bar').style.width=current_width+'%';
    }
  }else{
    if(enable_free_gift){
      current_text = eam_product_text;
      current_width = (total_cart_price/free_product_price)*100;
      free_shipping_price = free_product_price;
    }else if(eam_shipping_enable){
      current_width = (total_cart_price/free_shipping_price)*100;
      current_text = eam_shipping_text;
      disclarmair_text_update = true;
    }
    if(current_width>=100){
      shipping_text = eam_free_shipping_text;
      current_width = 97.00;
      document.querySelector('.eam-cart-free-shipping-bar-container').classList.add('eam-free-shipping');
      if(disclarmair_text_update){
        document.querySelector('.eam-cart-free-shipping-disclaimer').textContent=disclaimer_free_text;
      }
    }else{
      document.querySelector('.eam-cart-free-shipping-disclaimer').textContent=disclaimer_text;
      document.querySelector('.eam-cart-free-shipping-bar-container').classList.remove('eam-free-shipping');
      current_amount_needed = current_currency +""+( free_shipping_price - total_cart_price ).toFixed(2);
      shipping_text = 'Spend <strong>'+current_amount_needed+' </strong>'+current_text;
    }
    $('.eam-cart-free-shipping-text').html(shipping_text);
    document.querySelector('.eam-shipping-bar').style.width=current_width+'%';
  }
}

// Addons JS

  // Show Option on Click
  
  $(document).on('click','.eam-cc-addon-product-button',function(){
    if($(this).hasClass('eam-ajax-add')){
      var variant_id = $(this).data('product-id');
      addItemAddons(variant_id,$(this));
    }else{
      // Remove Other Shown Options
        var all_addon_with_options = $('.eam-cc-addon-product .eam-cc-addon-product-bottom');
        for(var j=0;j<all_addon_with_options.length;j++){
          $(all_addon_with_options[j]).parents('.eam-cc-addon-product').removeClass('eam-show-options');
          $(all_addon_with_options[j]).parents('.eam-cc-addon-product').find('.eam-cc-addon-product-button').text(addon_option_text);
          $(all_addon_with_options[j]).parents('.eam-cc-addon-product').find('.eam-cc-addon-product-button').removeClass('eam-ajax-add');
          // $(all_addon_with_options[j]).parents('.eam-cc-addon-product').find('.eam-cc-addon-product-button').removeClass('eam-ajax-outofstock');
          // $(all_addon_with_options[j]).parents('.eam-cc-addon-product').find('.eam-cc-addon-product-button').removeClass('eam-option-not-selected');
        }
      // Show Current Selected Option
        $(this).addClass('eam-ajax-add');
        // $(this).addClass('eam-option-not-selected');
        if($(this).hasClass('eam-ajax-outofstock')){
          $(this).text(addon_oos_text);
        }else{
          $(this).text(addon_atc_text);
        }
        $(this).parents('.eam-cc-addon-product').addClass('eam-show-options');
    }
  });

  // Option Change JS 
  $(document).on('change','.eam-ccap-option',function() {
    var all_option_element = $(this).parents('.eam-cc-addon-product-bottom').find('.eam-ccap-option');
    var all_option_selected = false;
    var product_handle = $(this).parents('.eam-cc-addon-product').data('product-handle');
    var current_selected_options = {};
    var current_selected_options_merged;
    for ( var j = 0 ; j < all_option_element.length ; j++){
      if($(all_option_element[j])!=undefined){
        var current_value = $(all_option_element[j]).val();
        var current_option_name = $(all_option_element[j]).parents('.eam-cc-addon-product-option-container').data('product-option');
        current_selected_options[current_option_name] = current_value;
        if( j == 0 ){
          current_selected_options_merged = current_value;
        }else{
          current_selected_options_merged = current_selected_options_merged + ' / ' + current_value;
        }
        if(current_value!=null){
          all_option_selected = true;
        }else{
          all_option_selected = false;
          break;
        }
      }
    }
    if(all_option_selected){
      $(this).parents('.eam-cc-addon-product').find('.eam-cc-addon-product-button').removeClass('eam-option-not-selected');
      addon_find_variants(current_selected_options_merged,product_handle,$(this).parents('.eam-cc-addon-product'));
    }else{
      $(this).parents('.eam-cc-addon-product').find('.eam-cc-addon-product-button').addClass('eam-option-not-selected');
    }
  });

  // Finding which addon variant is selected and is it available or not
  function addon_find_variants(current_selected_options,product_handle,e) {
    jQuery.getJSON(window.Shopify.routes.root + 'products/'+product_handle+'.js', function(product) {
      for(variant in product.variants){
        var current_variant = product.variants[variant];
        if(current_variant.title == current_selected_options){
          // Changing Addon Current Image
          var variant_pice = current_currency + '' + (current_variant.price/100.00).toFixed(2);
          if(current_variant.featured_image!=null){
            var variant_image = current_variant.featured_image.src;
            if(variant_image.toLowerCase().includes('jpg')){
              variant_image = variant_image.replace('.jpg','_x180.jpg');
            }else if(variant_image.toLowerCase().includes('png')){
              variant_image = variant_image.replace('.png','_x180.png');
            }else if(variant_image.toLowerCase().includes('jpeg')){
              variant_image = variant_image.replace('.png','_x180.jpeg');
            }
            e.find('.eam-cc-addon-product-image')[0].src = variant_image;
          }
          e.find('.eam-cc-addon-product-price span').text(variant_pice);
          if(current_variant.available){
            e.find('button.eam-cc-addon-product-button.eam-ajax-add').removeClass('eam-ajax-outofstock');
            e.find('button.eam-cc-addon-product-button.eam-ajax-add').data('product-id',current_variant.id);
            e.find('button.eam-cc-addon-product-button.eam-ajax-add').text(addon_atc_text);
            
          }else{
            e.find('button.eam-cc-addon-product-button.eam-ajax-add').addClass('eam-ajax-outofstock');
            e.find('button.eam-cc-addon-product-button.eam-ajax-add').text(addon_oos_text);
          }
        }
      }
    });
  }

  // Rendering Addons Based on Collection
  function RenderAddonsCollection(cart) {
    if(addon_collection!=''){
      jQuery.getJSON('/collections/'+addon_collection+'/products.json', function(products) {
        var k = 0;
        var all_products = products.products;
        if (all_products.length > 0){
          $('.eam-cart-addon-item-container').empty();
          for (product in all_products){
            var current_product = all_products[product];
            var cart_product_nexist = true;
            for(var l=0;l<cart.items.length;l++){
              if(cart.items[l].product_id == current_product.id){
                  cart_product_nexist=false;
                  break;
              }
            }
            if(current_product.handle == free_gift_product_handle){
              cart_product_nexist=false;
            }
            if(k==3){
              // break;
              if($('.eam-cart-addon-item-load-more').length==0){
                $('.eam-cart-addon-item-container').append('<div class="eam-cart-addon-item-load-more">Load More</div>')
              }
  
            }
            if(current_product!=undefined && cart_product_nexist){
              k++;
              var addon_product;
              var featured_image = current_product.images[0].src;
              if(featured_image.toLowerCase().includes('jpg')){
                featured_image = featured_image.replace('.jpg','_x180.jpg');
              }else if(featured_image.toLowerCase().includes('png')){
                featured_image = featured_image.replace('.png','_x180.png');
              }else if(featured_image.toLowerCase().includes('jpeg')){
                featured_image = featured_image.replace('.png','_x180.jpeg');
              }
              var price = current_currency + '' + current_product.variants[0].price;
              var atc_text = addon_atc_text;
              var first_variant_id = current_product.variants[0].id;
              var url = '/products/'+current_product.handle;
              var atc_class='eam-cc-addon-product-button eam-ajax-add';
              var eam_complete_options =  undefined;
              if(current_product.variants.length>1){
                atc_text = addon_option_text;
                atc_class='eam-cc-addon-product-button eam-option-not-selected';
                eam_complete_options = find_addons_options(current_product);  
              }  
              if(eam_complete_options == undefined){
                addon_product = '<div class="eam-cc-addon-product" data-product-id="'+current_product.id+'" data-product-handle="'+current_product.handle+'"> <div class="eam-cc-addon-product-top"> <a href="'+url+'" tabindex="-1" aria-hidden="true"> <img alt="" class="eam-cc-addon-product-image " src="'+featured_image+'"> </a> <div class="eam-header-price-container"> <a href="'+url+'"> <h4 class="eam-cc-addon-product-title">'+current_product.title+'</h4> </a> <a class="eam-cc-addon-product-price-container" href="'+url+'"> <h4 class="eam-cc-addon-product-price"> <span class="money" data-currency="'+current_currency+'">'+price+'</span> </h4> </a> <div class="eam-cc-addon-product-button-container"> <button type="button" class="'+atc_class+'" data-product-url="'+url+'" data-product-handle="'+current_product.handle+'" data-product-id="'+first_variant_id+'">'+atc_text+'</button> </div> </div> </div></div>'
              }else{
                addon_product = '<div class="eam-cc-addon-product" data-product-id="'+current_product.id+'" data-product-handle="'+current_product.handle+'"> <div class="eam-cc-addon-product-top"> <a href="'+url+'" tabindex="-1" aria-hidden="true"> <img alt="" class="eam-cc-addon-product-image " src="'+featured_image+'"> </a> <div class="eam-header-price-container"> <a href="'+url+'"> <h4 class="eam-cc-addon-product-title">'+current_product.title+'</h4> </a> <a class="eam-cc-addon-product-price-container" href="'+url+'"> <h4 class="eam-cc-addon-product-price"> <span class="money" data-currency="'+current_currency+'">'+price+'</span> </h4> </a> <div class="eam-cc-addon-product-button-container"> <button type="button" class="'+atc_class+'" data-product-url="'+url+'" data-product-handle="'+current_product.handle+'" data-product-id="'+current_product.id+'">'+atc_text+'</button> </div> </div> </div><div class="eam-cc-addon-product-bottom">'+eam_complete_options+'</div> </div>'
              }
              $('.eam-cart-addon-item-container').append(addon_product);
            }
          }
          if($('.eam-cc-addon-product').length==0){
            $('.eam-cart-addon-item-container').html('<p class="eam_addon_message">Collection Complete</p>')
          }
        }else{
          $('.eam-cart-addon-item-container').html('<p class="eam_addon_message">Collection Complete</p>')
        }
        if($('.eam-cc-addon-product').length>3){
          $('.eam-cart-addon-item-load-more').show();
        }else{
          $('.eam-cart-addon-item-load-more').hide();
        }
      });      
    }

  }

  // Render Empty Cart Addons

  function RenderEmptyAddons(cart){
    $('.eam-cart-middle-container').css('padding','0px 20px');
    $('.eam-cart-addon-heading-container').hide();
    $('.eam-cart-addon-item-container').empty();
    if(empty_cart_product_benefits != undefined){
      $('.eam-cart-addon-item-container').append('<div class="eam-empty-cart-addons-product-container"><a href="'+empty_cart_product_url+'" class="eam-empty-cart-addons-product-content"> <div class="eam-empty-cart-addons-product-image"> <img class="eam-empty-cart-addons-product-img" src="'+empty_cart_product_image+'"> </div> <div class="eam-empty-cart-addons-product-text-content"> <p class="eam-empty-cart-addons-product-tag">BEST SELLER</p> <h3 class="eam-empty-cart-addons-product-title">'+empty_cart_product_title+'</h3> <div class="eam-empty-cart-addons-product-price-container"><p class="eam-empty-cart-addons-product-price">'+empty_cart_product_price+'</p><p class="eam-empty-cart-addons-product-compare_at_price">'+empty_cart_product_compare_at_price+'</p><p class="eam-empty-cart-addons-product-save-price">Save '+empty_cart_product_save_price+'</p></div>  </div> </a> <div class="eam-empty-cart-addons-benefits-content"> '+empty_cart_product_benefits+' </div> </div><div class="eam-empty-cart-addons-button-content"> <div class="eam-empty-cart-addons-button"> <a href="'+empty_cart_product_url+'" class="eam-empty-cart-addons-button-text">SHOP '+empty_cart_product_title+'</a> </div> <div class="eam-empty-cart-addons-button-rating"> <img class="eam-empty-cart-addons-button-rating-image" src="https://cdn.shopify.com/s/files/1/0658/8769/files/green-star.svg?v=1686080992"> <p class="eam-empty-cart-addons-button-rating-text">965+ 5 STAR REVIEWS</p> </div> </div> ');
    }else{
      $('.eam-cart-addon-item-container').append('<div class="eam-empty-cart-addons-product-container"><a href="'+empty_cart_product_url+'" class="eam-empty-cart-addons-product-content"> <div class="eam-empty-cart-addons-product-image"> <img class="eam-empty-cart-addons-product-img" src="'+empty_cart_product_image+'"> </div> <div class="eam-empty-cart-addons-product-text-content"> <p class="eam-empty-cart-addons-product-tag">BEST SELLER</p> <h3 class="eam-empty-cart-addons-product-title">'+empty_cart_product_title+'</h3>  </div> </a><div class="eam-empty-cart-addons-button-content"> <div class="eam-empty-cart-addons-button"> <a href="'+empty_cart_product_url+'" class="eam-empty-cart-addons-button-text">SHOP '+empty_cart_product_title+'</a> </div> <div class="eam-empty-cart-addons-button-rating"> <img class="eam-empty-cart-addons-button-rating-image" src="https://cdn.shopify.com/s/files/1/0658/8769/files/green-star.svg?v=1686080992"> <p class="eam-empty-cart-addons-button-rating-text">965+ 5 STAR REVIEWS</p> </div> </div> ');
    }
    
     
  }
  
  // Finding Addons Options and returning them
  function find_addons_options(current_product) {
    if(current_product.options.length>=1 && current_product.options[0].values!="Default Title" && current_product.options[0].values.length>=1 ){
      var eam_options=[],eam_complete_options='';
      for(k=0;k<current_product.options.length;k++){  
        for(j=0;j<current_product.options[k].values.length;j++){
          if(j!=0){
            eam_options[k]=eam_options[k]+'<option>'+current_product.options[k].values[j]+'</option>';
          }else{
            eam_options[k]='<option>'+current_product.options[k].values[j]+'</option>';

          }
        }
      }

      for(k=0;k<current_product.options.length;k++){  
        if(current_product.options[k].values.length>=1 && current_product.options[k].values[0]!="Default Title"){

          if(k==0){
            eam_complete_options='<div class="eam-cc-addon-product-option-container" data-product-option="'+current_product.options[k].name+'"><select class="eam-ccap-option"><option val="eam-none" selected disabled>'+current_product.options[k].name+'</option>'+eam_options[k]+'</select></div>'
          }
          else{
            eam_complete_options=eam_complete_options+'<div class="eam-cc-addon-product-option-container" data-product-option="'+current_product.options[k].name+'"><select class="eam-ccap-option"><option val="eam-none" selected disabled>'+current_product.options[k].name+'</option>'+eam_options[k]+'</select></div>';
          }
        }
      }
    }
    return eam_complete_options;  
  }

  function RenderAddonsTags(cart) {
    var tag;
    var product_handle;
    var product_title;
    if(cart.items[0].handle!='routeins'){
      product_title=cart.items[0].product_title;
    }else{
      last_product_id=cart.items[1].product_id;
      product_handle=cart.items[1].handle;
      product_title=cart.items[1].product_title;
    }
    var tag='',final_url,all_custom_collections;
    if(eam_collections_handles.length>0){
      all_custom_collections = eam_collections_handles.split('\n');
    }else{
      RenderAddonsCollection(cart);
    }
    if(product_title.split('-').length>1){
      tag = product_title.split('-')[product_title.split('-').length-1].trim().split('/')[0].toLowerCase(); 
      for(j=0;j<all_custom_collections.length;j++){
        var custom_product_title = all_custom_collections[j].split(':');
        if(custom_product_title[0].toLowerCase().trim() ==  tag.toLowerCase().trim()){
          tag  = custom_product_title[1].toLowerCase().trim();
          break;
        }
      }
      
      final_url='/collections/'+tag+'/products.json';
    }else{
      final_url='/collections/all/products.json';
    }
    
    jQuery.getJSON(final_url, function(products) {
      var k = 0;
      var all_products = products.products;
      if (all_products.length > 0){
        $('.eam-cart-addon-item-container').empty();
        for (product in all_products){
          var current_product = all_products[product];
          var cart_product_nexist = true;
          for(var l=0;l<cart.items.length;l++){
            if(cart.items[l].product_id == current_product.id){
                cart_product_nexist=false;
                break;
            }
          }
          if(current_product.handle == free_gift_product_handle){
            cart_product_nexist=false;
          }
          if(k==3){
            // break;
            if($('.eam-cart-addon-item-load-more').length==0){
              $('.eam-cart-addon-item-container').append('<div class="eam-cart-addon-item-load-more">Load More</div>')
            }

          }
          if(current_product!=undefined && cart_product_nexist){
            k++;
            var addon_product;
            var featured_image = current_product.images[0].src;
            if(featured_image.toLowerCase().includes('jpg')){
              featured_image = featured_image.replace('.jpg','_x180.jpg');
            }else if(featured_image.toLowerCase().includes('png')){
              featured_image = featured_image.replace('.png','_x180.png');
            }else if(featured_image.toLowerCase().includes('jpeg')){
              featured_image = featured_image.replace('.png','_x180.jpeg');
            }
            var price = current_currency + '' + current_product.variants[0].price;
            var atc_text = addon_atc_text;
            var first_variant_id = current_product.variants[0].id;
            var url = '/products/'+current_product.handle;
            var atc_class='eam-cc-addon-product-button eam-ajax-add';
            var eam_complete_options =  undefined;
            if(current_product.variants.length>1){
              atc_text = addon_option_text;
              atc_class='eam-cc-addon-product-button eam-option-not-selected';
              eam_complete_options = find_addons_options(current_product);  
            }  
            if(eam_complete_options == undefined){
              addon_product = '<div class="eam-cc-addon-product" data-product-id="'+current_product.id+'" data-product-handle="'+current_product.handle+'"> <div class="eam-cc-addon-product-top"> <a href="'+url+'" tabindex="-1" aria-hidden="true"> <img alt="" class="eam-cc-addon-product-image " src="'+featured_image+'"> </a> <div class="eam-header-price-container"> <a href="'+url+'"> <h4 class="eam-cc-addon-product-title">'+current_product.title+'</h4> </a> <a class="eam-cc-addon-product-price-container" href="'+url+'"> <h4 class="eam-cc-addon-product-price"> <span class="money" data-currency="'+current_currency+'">'+price+'</span> </h4> </a> <div class="eam-cc-addon-product-button-container"> <button type="button" class="'+atc_class+'" data-product-url="'+url+'" data-product-handle="'+current_product.handle+'" data-product-id="'+first_variant_id+'">'+atc_text+'</button> </div> </div> </div></div>'
            }else{
              addon_product = '<div class="eam-cc-addon-product" data-product-id="'+current_product.id+'" data-product-handle="'+current_product.handle+'"> <div class="eam-cc-addon-product-top"> <a href="'+url+'" tabindex="-1" aria-hidden="true"> <img alt="" class="eam-cc-addon-product-image " src="'+featured_image+'"> </a> <div class="eam-header-price-container"> <a href="'+url+'"> <h4 class="eam-cc-addon-product-title">'+current_product.title+'</h4> </a> <a class="eam-cc-addon-product-price-container" href="'+url+'"> <h4 class="eam-cc-addon-product-price"> <span class="money" data-currency="'+current_currency+'">'+price+'</span> </h4> </a> <div class="eam-cc-addon-product-button-container"> <button type="button" class="'+atc_class+'" data-product-url="'+url+'" data-product-handle="'+current_product.handle+'" data-product-id="'+current_product.id+'">'+atc_text+'</button> </div> </div> </div><div class="eam-cc-addon-product-bottom">'+eam_complete_options+'</div> </div>'
            }
            $('.eam-cart-addon-item-container').append(addon_product);
          }
        }
        if($('.eam-cc-addon-product').length==0){
          $('.eam-cart-addon-item-container').html('<p class="eam_addon_message">Collection Complete</p>')
        }
      }else{
        RenderAddonsCollection(cart);
        // $('.eam-cart-addon-item-container').html('<p class="eam_addon_message">Collection Complete</p>')
      }
      if($('.eam-cc-addon-product').length>3){
          $('.eam-cart-addon-item-load-more').show();
          
      }else{
        $('.eam-cart-addon-item-load-more').hide();
      }
    });      
          

     
  }

  function EamFreeProduct(cart){
    if(cart.items.length>0){
      var free_gift_variant_id = free_gift_product_variant;
      var free_product_length=$('.eam-cart-item.free-item[data-product-handle="'+free_gift_product_handle+'"]').length;
      var current_cart_price = cart.total_price/100.00;
      if(current_cart_price>=free_gift_price){
        localStorage.setItem('add_item','true');
      }else{
        localStorage.setItem('add_item','false');
      }
      
      if(free_product_length<=0 && localStorage.getItem('add_item') == 'true'){
        addItemGeneric(free_gift_variant_id,1);
      }else if(free_product_length > 0 && localStorage.getItem('add_item') == 'false'){
        free_gift_variant_id=$('.eam-cart-item.free-item[data-product-handle="'+free_gift_product_handle+'"]').data('product-line');
        change_item_quantity(free_gift_variant_id,0);
      }
    }else{
      localStorage.setItem('item_added','false');
    }

  }

  function addItemGeneric(variant_id,quantity) {
     $.ajax({
        type: 'POST', 
        url: '/cart/add.js',
        dataType: 'json', 
        data: {
          id: variant_id,
          quantity: quantity
        },
        success: addToCartfreeOk
     });
  }
  function addToCartfreeOk(product) { 
    openMainCart();
  }


  document.querySelectorAll('.product-item-bolden-add-to-cart').forEach(function (product_item) {
    product_item.addEventListener('click',function(e) {
      e.preventDefault();
      let variant_id = this.dataset.variant;
      addItemGeneric(variant_id,1);
    })
  })





// Order Note
if(enable_order_note){
   $('.eam-custom-ordernote-container').on("click",function(){
    $('.eam-custom-ordernote-data-container').show();
    $(this).hide();            
  });
  $('.eam-custom-ordernote-cancel').on("click",function(){
    $('.eam-custom-ordernote-data-container').hide();
    $('.eam-custom-ordernote-container').show();
  });
  $('.eam-custom-ordernote-save').on("click",function(){
    var current_note=$('#eam-custom-ordernote').val();
    $('.eam-custom-ordernote-data-container').hide();
    $('.eam-custom-ordernote-container').show();
    if($('.eam-custom-edit-ordernote-text').length<1){
      $('.eam-custom-ordernote-data-heading').text('Edit '+order_note_text);
      $('.eam-custom-ordernote-container').append('<p class="eam-custom-edit-ordernote-text">Edit note</p>');
    } 
    $('.eam-custom-ordernote-text').addClass('edit-order-note-text');  
    $('.eam-custom-ordernote-text').text(current_note);
    $('.eam-custom-ordernote-text').css('color','#6b6668');
    $.ajax({
        url: '/cart/update.js',
        type: 'POST',
        data: {note: current_note},
        success: function(result) { 
        }
    });
  });
}

document.querySelector('.eam-checkout-cart-button').addEventListener('click',function() {
  this.classList.add('eam-checkout-loading');
  this.textContent = 'Please Wait...';
  window.location.href="/checkout";
})

$(document).on('click','.eam-cart-addon-item-load-more',function() {
  if($('.eam-cc-addon-product').length>3){
      $('.eam-cart-addon-item-load-more').show();
      if($('.eam-cart-addon-item-load-more').text()=="Load More"){
          $('.eam-cc-addon-product:hidden').show();
          $(this).text('Show Less');      
      }else{
        $('.eam-cc-addon-product:nth-child(n+4)').hide();
        $(this).text('Load More');    
      }
  }else{
    $('.eam-cart-addon-item-load-more').hide();
  }


});

  $(window).on('popstate', function() {
    if(document.querySelector('.eam-checkout-loading')!=null){
      document.querySelector('.eam-checkout-loading').classList.remove('eam-checkout-loading');
      $('.eam-checkout-cart-button').load(window.location.href+ ' ' + '.eam-checkout-cart-button');
    }
  });
  
